<template>
    <sonicu-button  bg-color="bg-green-600"
                    bg-color-hover="bg-green-500"
                    bg-color-active="bg-green-600"
                    bg-color-focus="bg-green-600"
                    text-color="text-white"
                    text-color-hover="text-white"
                    border-color="border-transparent"
                    border-color-hover="border-green-700"
                    border-color-active="border-green-700"
                    @click="$emit('click', $event)"
    >
        <slot></slot>
    </sonicu-button>

</template>

<script>

import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
    name: "ButtonGreenPrimary",
    mixins: [],
    emits: ['click'],
    components: {SonicuButton},
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>